// 市场观察域共享格式化 helper。此前 number/integer/signed/tone 在 8 个文件里各写一份，
// 且签名不一致（详见 CLAUDE.md 跨前后端评估清单的教训）。这里收敛「有守卫版」——
// null/undefined/"" 一律显示 "--"。
//
// 注意：InstrumentDetailPage/MarketAtoms/IndustryActivity/chartOptions 仍保留各自本地实现，
// 因为它们是「无守卫版」(Number(null)===0 会渲染 "+0.00%")，统一成守卫版会改变展示。
// 那几处要合并，得先确认对应字段不会为 null，属于单独一轮的事。

export function number(value, digits = 2) {
  if (value === null || value === undefined || value === "") return "--";
  const parsed = Number(value);
  return Number.isFinite(parsed)
    ? parsed.toLocaleString("zh-CN", { minimumFractionDigits: digits, maximumFractionDigits: digits })
    : "--";
}

export function integer(value) {
  if (value === null || value === undefined || value === "") return "--";
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed.toLocaleString("zh-CN", { maximumFractionDigits: 0 }) : "--";
}

export function signed(value, suffix = "%", digits = 2) {
  if (value === null || value === undefined || value === "") return "--";
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return "--";
  return `${parsed > 0 ? "+" : ""}${parsed.toFixed(digits)}${suffix}`;
}

export function shortDate(date) {
  return date ? date.slice(5) : "";
}

// tone 依赖各文件自己 import 的 CSS module（up/down/flat 是 module-scoped 哈希类名），
// 所以 styles 必须由调用方传入，不能在此闭包里固定一个 styles。
export function toneClass(value, styles) {
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed === 0) return styles.flat;
  return parsed > 0 ? styles.up : styles.down;
}
